// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForSalePropertySearchResult_forSalePropertyV5",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertySearchResultCard_propertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertySearchResult_StatusLabel_forSalePropertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyLocationForCard_propertyV5"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "priceFormat",
          "value": "FULL"
        },
        {
          "kind": "Literal",
          "name": "priceRangeFormat",
          "value": "SHORT"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PropertyPrice_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertyAttributes_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertySearchResult_Agent_forSalePropertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertySearchResultTimestamp_propertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertySearchResultActions_propertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UseShouldShowPropertyDetails_propertyV5"
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
